import { useCallback, useMemo, type ReactNode } from 'react';
import { ExportContext, type ExportHooks, type CreateExportJobVariables } from '@/contexts/ExportContext';
import { useApiConfig } from '@/providers/ApiConfigProvider';
import { createExportJobMutation } from '@/lib/api/export';
import type { CreateExportJobMutationResult, Forms } from '@/types/export';

interface ExportProviderProps {
  children: ReactNode;
}

export function ExportProvider({ children }: ExportProviderProps) {
  const apiConfig = useApiConfig();

  const handleCreateExportJob = useCallback(
    async (variables: CreateExportJobVariables<Forms>): Promise<CreateExportJobMutationResult> => {
      return createExportJobMutation(apiConfig, variables.export);
    },
    [apiConfig],
  );

  const value = useMemo<ExportHooks<Forms>>(
    () => ({ createExportJob: handleCreateExportJob }),
    [handleCreateExportJob],
  );

  return <ExportContext.Provider value={value}>{children}</ExportContext.Provider>;
}
